module.exports = __webpack_public_path__ + "static/img/qItem3-img4.2c2cb9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem3-img4.png
// module id = YCIp
// module chunks = 1